<template>
  <v-card color='primary' outlined>
    <div class='d-flex pa-2'>
      <v-btn icon color='white' @click="$emit('prev')"><v-icon>mdi-chevron-double-left</v-icon></v-btn>
      <v-spacer></v-spacer>
      <v-btn text color='white' :disabled='disabled' @click="$emit('today')"><v-icon left>mdi-calendar</v-icon>This week</v-btn>
      <v-spacer></v-spacer>
      <v-btn icon color='white' @click="$emit('next')"><v-icon>mdi-chevron-double-right</v-icon></v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'day-button',
  props: {
    disabled: {
      required: false,
      type: Boolean,
      default: false
    }
  }
}
</script>
